const hoverOutElement = document.getElementById('header-primary')
const hoverInElements = document.querySelectorAll(
    '#header-primary #menu-main li'
)
const megaMenus = document.querySelectorAll('.megamenu')

hoverInElements.forEach((hoverInElement, index) => {
    const megaMenu = document.getElementById(`megamenu-${index}`)

    hoverInElement.addEventListener('mouseenter', () => {
        megaMenus.forEach((megaMenu) => megaMenu.classList.add('hidden'))

        if (megaMenu) {
            megaMenu.classList.remove('hidden')
        }
    })
})

hoverOutElement.addEventListener('mouseleave', () => {
    megaMenus.forEach((megaMenu) => megaMenu.classList.add('hidden'))
})
